<template>
  <v-container fluid>
    <v-select
      v-model="value"
      :items="items"
      class="mt-3"
      style="width: 70px;"
      @change="changeLangCode"
    >
      <template v-slot:item="{ item, index }">
        <gb-flag
          :code="item"
          size="small"
        />
      </template>

      <template v-slot:selection="{ item, index }">
        <gb-flag
          :code="item"
          size="small"
        />
      </template>
    </v-select>
  </v-container>
</template>

<script>

import data_tsl from "@/data/country_code.js";
import tsl from "@/utils/translation.js";

export default {
  data(){
    return {
      items: tsl.getLangList(data_tsl.allowed_country),
      value: tsl.getIETFCountry(this.$root.$i18n.locale)
    }
  },

  methods: {
    changeLangCode() {
      this.$root.$i18n.locale = tsl.buildIETFCountryLang(this.value)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
